<template>
  <DashboardLayout>
    <h3>Manage Guests</h3>
    <div v-if="toastMessage" class="toast" :class="[toastType, { show: toastVisible }]">
      <span class="checkmark">✔</span>
      {{ toastMessage }}
    </div>
    
    <!-- Delete Confirmation Dialog -->
    <div v-if="confirmDialog" class="dialog-overlay">
      <div class="dialog">
        <h4 style="text-align: center;">Confirm Delete</h4>
        <p>Are you sure you want to delete this guest?</p>
        <div class="dialog-actions">
          <button class="btn-primary" @click="confirmDelete">Yes</button>
          <button class="btn-secondary" @click="closeConfirmDialog">No</button>
        </div>
      </div>
    </div>


    <!-- Search -->
    <div class="search-box">
      <input v-model="searchQuery" @input="searchGuests" placeholder="Search guest..." />
      <button class="btn-primary" @click="showDialog = true">+ Add Guest</button>
    </div>

    <!-- Add Guest Dialog -->
    <div v-if="showDialog" class="dialog-overlay">
      <div class="dialog">
        <h4 style="text-align: center;">Add New Guest</h4>
        <form @submit.prevent="addGuest">
          <input v-model="newGuest" style="width: 97%;" placeholder="Guest name" />
          <div class="dialog-actions">
            <button type="submit" class="btn-primary">Save</button>
            <button type="button" class="btn-secondary" @click="closeDialog">Cancel</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Edit Guest Dialog -->
    <div v-if="editDialog" class="dialog-overlay">
      <div class="dialog">
        <h4 style="text-align: center;">Edit Guest</h4>
        <form @submit.prevent="updateGuestName">
          <input v-model="editGuestName" style="width: 97%;" placeholder="Guest name" />
          <div class="dialog-actions">
            <button type="submit" class="btn-primary">Update</button>
            <button type="button" class="btn-secondary" @click="closeEditDialog">Cancel</button>
          </div>
        </form>
      </div>
    </div>

    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Attending</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="guest in filteredGuests" :key="guest._id">
          <td>{{ guest.name }}</td>
          <td>{{ guest.attending ? "Yes" : "No" }}</td>
          <td class="btn-col">
            <button class="btn " @click="openEditDialog(guest)">Edit</button>
            <button class="btn " @click="copyGuestLink(guest)">Copy Link</button>
            <button class="btn " @click="toggleGuest(guest)">Toggle</button>
            <button class="btn" @click="askDeleteGuest(guest._id)">Delete</button>

            <!-- <button class="btn " @click="deleteGuest(guest._id)">Delete</button> -->
            <!-- <button class="action" @click="shareGuest(guest)">Share</button> -->

          </td>
        </tr>
      </tbody>
    </table>
  </DashboardLayout>
</template>

<script>
import API from "../services/api";
import DashboardLayout from "../components/DashboardLayout.vue";

export default {
  components: { DashboardLayout },
  data() {
    return {
      guests: [],
      newGuest: "",
      showDialog: false,
      editDialog: false,
      editGuestId: null,
      editGuestName: "",
      searchQuery: "",
      toastMessage: "",
      toastVisible: false,
      toastType: "success",
      confirmDialog: false,
      deleteGuestId: "" 
    };
  },

  async created() {
    this.fetchGuests();
  },
  computed: {
    filteredGuests() {
      if (!this.searchQuery.trim()) return this.guests;
      return this.guests.filter(g =>
        g.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  methods: {
    async fetchGuests() {
      try {
        const res = await API.get("/guests", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        this.guests = res.data;
      } catch (err) {
        console.error("Failed to fetch guests:", err.response?.data || err.message);
      }
    },
    async addGuest() {
      if (!this.newGuest.trim()) return;
      try {
        await API.post(
          "/guests",
          { name: this.newGuest, attending: false },
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
        this.newGuest = "";
        this.showDialog = false;
        this.toastMessage = "New guest added successfully!";
        this.toastType = "success";
        this.toastVisible = true;
        this.fetchGuests();
      } catch (err) {
        console.error("Failed to add guest:", err.response?.data || err.message);
        this.toastMessage = "Failed to add guest:", err.response?.data || err.message;
        this.toastType = "error";
        this.toastVisible = true;
      }
    },
    closeDialog() {
      this.showDialog = false;
      this.newGuest = "";
    },
    async toggleGuest(guest) {
      try {
        await API.put(
          `/guests/${guest._id}`,
          { attending: !guest.attending },
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
        this.fetchGuests();
      } catch (err) {
        console.error("Failed to toggle guest:", err.response?.data || err.message);
      }
    },
    // async deleteGuest(id) {
    //   try {
    //     await API.delete(`/guests/${id}`, {
    //       headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    //     });
    //     this.toastMessage = "Delete guest name successfully!";
    //     this.toastType = "error";
    //     this.toastVisible = true;
    //     this.fetchGuests();
    //   } catch (err) {
    //     console.error("Failed to delete guest:", err.response?.data || err.message);
    //   }
    // },
      askDeleteGuest(id) {
        this.deleteGuestId = id;
        this.confirmDialog = true;
      },
      closeConfirmDialog() {
        this.confirmDialog = false;
        this.deleteGuestId = ""; // ✅ reset to empty string
      },
      async confirmDelete() {
        try {
          await API.delete(`/guests/${this.deleteGuestId}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
          });
          this.toastMessage = "Guest deleted successfully!";
          this.toastType = "error";
          this.toastVisible = true;
          this.fetchGuests();
        } catch (err) {
          console.error("Failed to delete guest:", err.response?.data || err.message);
        } finally {
          this.closeConfirmDialog();
        }
      },
    shareGuest(guest) {
      // const link = `http://localhost:8080?id=${encodeURIComponent(guest._id)}`;
      const link = `${process.env.VUE_APP_BASE_URL}?id=${encodeURIComponent(guest._id)}`;
      navigator.clipboard.writeText(link).then(() => {
        alert(`Share link copied: ${link}`);
      });
    },


    copyGuestLink(guest) {
      const baseUrl = process.env.VUE_APP_BASE_URL || window.location.origin;
      const link = `${baseUrl}?id=${encodeURIComponent(guest._id)}`;

      navigator.clipboard.writeText(link)
        .then(() => {
          this.toastMessage = "Guest link copied successfully!";
          this.toastType = "success";
          this.toastVisible = true;

          // Hide after 3 seconds
          setTimeout(() => {
            this.toastVisible = false;
            this.toastType = "error";
            this.toastMessage = "";
          }, 3000);
        })
        .catch(err => {
          console.error("Failed to copy link:", err);
        });
    },


    openEditDialog(guest) {
      this.editDialog = true;
      this.editGuestId = guest._id;
      this.editGuestName = guest.name;
    },
    closeEditDialog() {
      this.editDialog = false;
      this.editGuestId = null;
      this.editGuestName = "";
    },
    async updateGuestName() {
      if (!this.editGuestName.trim()) return;
      try {
        await API.put(
          `/guests/${this.editGuestId}`,
          { name: this.editGuestName },
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
        this.closeEditDialog();
        this.toastMessage = "Update guest name successfully!";
        this.toastType = "success";
        this.toastVisible = true;
        this.fetchGuests();
      } catch (err) {
        console.error("Failed to update guest:", err.response?.data || err.message);
      }
    }
  }
};
</script>


<style scoped>

.search-box {
  margin: 15px 0;
  display: flex;
  justify-content: space-between;
}
.search-box input {
  /* width: 200px; */
  width: 40%;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
}
.dialog-actions {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  gap: 10px;
}
.btn-primary {
  padding: 8px 12px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
}
.btn-secondary {
  padding: 8px 12px;
  background: #6c757d;
  color: #fff;
  border: none;
  border-radius: 4px;
}
.action {
  margin-right: 10px;
}

.add-form {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
}

.add-form input {
  width: 100px;
}

table {
  width: 90%;
  border-collapse: collapse;
  background: #fff;
}

th, td {
  padding: 10px;
  border: 1px solid #ddd;
}

.btn-col {
  display: flex;
  justify-content: center;
}
.btn {
  margin-right: 10px;
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  background-color: #1e3a8a; /* darker blue */
  color: #fff;
}




 .toast {
  position: fixed;
  bottom: 20px;
  right: 20px;
  color: #fff;
  padding: 12px 20px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.4s ease, transform 0.4s ease;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.toast.show {
  opacity: 1;
  transform: translateY(0);
}

.toast.success {
  background: #28a745; /* green */
}

.toast.error {
  background: #dc3545; /* red */
}

.checkmark {
  font-size: 18px;
}

</style>
